import React from 'react';
import { Form, Input, Label, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { AwesomeButton } from 'react-awesome-button';
import 'react-awesome-button/dist/themes/theme-blue.css';
function UserDetails(props) {
	let { isOpen, toggleUserDetails } = props;
	return (
		<div>
			<Modal centered isOpen={isOpen} toggle={toggleUserDetails}>
				<ModalHeader toggle={toggleUserDetails}>
					Customer Details
				</ModalHeader>
				<ModalBody>
					<Form>
						<Label>Name</Label>
						<Input type='text' required />
						<Label className='mt-2'>Phone</Label>
						<Input type='tel' required />
						<Label className='mt-2'>Email</Label>
						<Input type='email' required />
						<AwesomeButton type='primary' className='mt-3 w-100'>
							Submit
						</AwesomeButton>
					</Form>
				</ModalBody>
			</Modal>
		</div>
	);
}

export default UserDetails;
